<template>
  <div class="card-count" :class="`bgm-${color}`">
    <div class="clearfix">
      <div class="count">
        <small>{{ title }}</small>
        <h2>
          <span v-if="!loading">
            <slot></slot>
          </span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    color: {
      type: String,
      default: '',
      required: false,
    },
  },
}
</script>

<style scoped>
.card-count {
  position: relative;
}

.count {
  overflow: hidden;
  padding: 14px 16px 16px 18px;
}

h2 {
  margin: 0;
  line-height: 100%;
  font-size: 22px;
  font-weight: 300;
}

small {
  opacity: 50%;
  font-weight: 500;
  margin-bottom: 2px;
  display: block;
}

h2,
small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
